import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ErrorDto } from '../../../models/dtos/error.dto';
import { ForgotPasswordRequest } from '../../../models/requests/forgetpassword.request';
import { Errors } from '../../errors';
import forgotPasswordRequest from './forgotpassword.repository';

type InitialState = {
  loading: boolean;
  data?: boolean;
  error?: ErrorDto;
};
const initialState: InitialState = {
  loading: false,
  data: undefined,
  error: undefined,
};

export const forgotPassword = createAsyncThunk(
  'forgotPassword',
  async (request: ForgotPasswordRequest, { dispatch }) => {
    await forgotPasswordRequest(request);
    return true;
  }
);

const forgotPasswordSlice = createSlice({
  name: 'forgotPassword',
  initialState,
  reducers: {
    forgotPasswordReset: (state) => {
      state.loading = false;
      state.data = undefined;
      state.error = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(forgotPassword.pending, (state) => {
      state.loading = true;
      state.data = undefined;
      state.error = undefined;
    });
    builder.addCase(forgotPassword.fulfilled, (state) => {
      state.loading = false;
      state.data = true;
    });
    builder.addCase(forgotPassword.rejected, (state, action) => {
      state.loading = false;
      state.error = Errors.getErrorDtoFromApiError(action.error);
    });
  },
});

export default forgotPasswordSlice.reducer;
export const { forgotPasswordReset } = forgotPasswordSlice.actions;
